import { RouteConfig } from "vue-router";
import { Network } from "@/network";

const PreviewRoute: Array<RouteConfig> = [
    {
        path: "/preview",
        component: () => import("@/views/admin/preview/Preview.vue"),
        beforeEnter: (to, from, next) => {
            console.log('router here');
            next();
            // if (Network.authCheck()) {
            //     next();
            // } else {
            //     next("/login");
            // }
        }
    }
];

export { PreviewRoute };
